import React from "react";
import "./changepassword.scss";
import Closeicon from "../common/closeicon";
import Input from "../../input";
import Button from "../../button";
import { useState } from "react";
import EyeIcon from "../../../assets/icons/eye.svg";
import HideEyeIcon from "../../../assets/icons/hideeye.svg";
import { getUser } from "../../../helpers/utils/auth.util";
import { useDispatch, useSelector } from "react-redux";
import { chnagePassword } from "../../../store/slices/authSlice";
import toast from "react-hot-toast";

export default function Changepassword({
  setChangePasswordModel,
}) {
  const dispatch = useDispatch();
  const { authLoader } = useSelector((state) => state.auth);
  const user = getUser();

  const [password, setPassword] = useState({});
  const [errors, setErrors] = useState({});

  const [showEyeIcon, setShowEyeIcon] = useState([
    { show: false },
    { show: false },
    { show: false },
  ]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validForm = () => {
    let Fromvlid = true;
    let errors = {};

    if (user?.providers !== "google" && !password.old_password?.trim()) {
      Fromvlid = false;
      errors["old_password"] = "Old Password is required*";
    }
    if (!password.new_password?.trim()) {
      Fromvlid = false;
      errors["new_password"] = "New Password is required*";
    } else if (password.new_password.length < 8) {
      Fromvlid = false;
      errors["new_password"] = "Password must be at least 8 characters";
    }
    if (!password.confirm_password?.trim()) {
      Fromvlid = false;
      errors["confirm_password"] = "Confirm Password is required*";
    }
    if (password.new_password !== password.confirm_password) {
      Fromvlid = false;
      errors["confirm_password"] = "Password does not match with new password*";
    }

    setErrors(errors);
    return Fromvlid;
  };

  const handleChangePassword = async () => {
    if (!validForm()) return;

    const result = await dispatch(chnagePassword({
      old_password: password.old_password,
      new_password: password.new_password,
    }));

    if (result?.payload?.data?.success) {
      toast.success("Password changed successfully!");
      setChangePasswordModel(false);
    } else {
      toast.error(result?.payload?.data?.message || "Failed to change password");
    }
  };

  const handleShowEyeIcon = (index) => {
    let value = [...showEyeIcon];
    value[index].show = !value[index]?.show;
    setShowEyeIcon(value);
  };

  return (
    <div>
      <div className="modal-wrapper-change-password">
        <div className="change-password">
          <div className="modal-header">
            <p>Change Password</p>
            <Closeicon onClick={() => setChangePasswordModel(false)} />
          </div>
          <div className="modal-body">
            {user?.providers !== "google" && (
              <div className="input-bottom-alignment">
                <Input
                  type={showEyeIcon[0].show ? "text" : "password"}
                  label="Old Password"
                  name={"old_password"}
                  value={password?.old_password}
                  placeholder="Enter Old Password"
                  onChange={handleOnChange}
                  icon={showEyeIcon[0].show ? HideEyeIcon : EyeIcon}
                  error={errors?.old_password}
                  iconClick={() => handleShowEyeIcon(0)}
                />
              </div>
            )}
            <div className="input-bottom-alignment">
              <Input
                type={showEyeIcon[1].show ? "text" : "password"}
                label="New Password"
                name={"new_password"}
                value={password?.new_password}
                placeholder="Enter New Password"
                onChange={handleOnChange}
                icon={showEyeIcon[1].show ? HideEyeIcon : EyeIcon}
                error={errors?.new_password}
                iconClick={() => handleShowEyeIcon(1)}
              />
            </div>
            <div className="input-bottom-alignment">
              <Input
                type={showEyeIcon[2].show ? "text" : "password"}
                label="Confirm Password"
                name={"confirm_password"}
                value={password?.confirm_password}
                placeholder="Enter Confirm Password"
                onChange={handleOnChange}
                icon={showEyeIcon[2].show ? HideEyeIcon : EyeIcon}
                error={errors?.confirm_password}
                iconClick={() => handleShowEyeIcon(2)}
              />
            </div>
            <div className="button-right-alignment">
              <Button
                text="Update Password"
                onClick={handleChangePassword}
                loader={authLoader}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

